import { graphql, useStaticQuery } from 'gatsby';

const useMarketingProDetailData = () => {
  const {
    campaignBuildingMp4,
    customerEngagementImage,
    demoFormSection,
    directMailFaqs,
    driveRevenueImage,
    emailAutomationMp4,
    emailFaqs,
    emailPerformanceImage,
    emailSeo,
    heroInlineMarketingForm,
    heroVideoDirectMail,
    heroVideoEmail,
    heroVideoReputation,
    listingScanSocialIcons,
    marketingProVideo,
    mailSeo,
    measureRoiImage,
    reputationFaqs,
    reputationManagementMp4,
    reputationSeo,
    reviewSourcesMp4,
    videoBackground,
    yextListingsScanForm,
  } = useStaticQuery(graphql`
    query {
      emailSeo: contentfulSeo(contentful_id: { eq: "4b4sK0NQIjEPX1U3t2udv1" }) {
        ...Seo
      }
      mailSeo: contentfulSeo(contentful_id: { eq: "2UHYEBCTMuHYzlw1nmKFAr" }) {
        ...Seo
      }
      reputationSeo: contentfulSeo(contentful_id: { eq: "p4ob2ZAUVYE6iqKmYxeWK" }) {
        ...Seo
      }
      marketingProVideo: contentfulWistiaVideo(contentful_id: { eq: "3JRTQ4LiqijLIAnyFZf0g5" }) {
        ...WistiaVideo
      }
      heroVideoReputation: contentfulWistiaVideo(contentful_id: { eq: "4qD0s0ZTPiyLyL4xW2SNOi" }) {
        ...WistiaVideo
      }
      heroVideoEmail: contentfulWistiaVideo(contentful_id: { eq: "5x3lMtsFQGjhKNQ0uuHnnW" }) {
        ...WistiaVideo
      }
      heroVideoDirectMail: contentfulWistiaVideo(contentful_id: { eq: "32CqwX7gba2yqmOAhUWvTO" }) {
        ...WistiaVideo
      }
      customerEngagementImage: contentfulImage(contentful_id: { eq: "6GH5lEioHzlL8p3kQSd940" }) {
        ...WebsiteImage
      }
      driveRevenueImage: contentfulImage(contentful_id: { eq: "4JvgnQaQRbWAJ0mlX0NVrg" }) {
        ...WebsiteImage
      }
      emailPerformanceImage: contentfulImage(contentful_id: { eq: "2uZlYKxzpybNI3D4pRDXmI" }) {
        ...WebsiteImage
      }
      measureRoiImage: contentfulImage(contentful_id: { eq: "27dpPrHGpinOhFXrJIF40a" }) {
        ...WebsiteImage
      }
      heroInlineMarketingForm: contentfulInlineMarketingForm(
        contentful_id: { eq: "13t5Hn8kpNCotq4LLEA40p" }
      ) {
        ...InlineMarketingForm
      }
      demoFormSection: contentfulRowContent(contentful_id: { eq: "4PQ2B7ZKmUQCag24iSiJzo" }) {
        ...RowContent
      }
      videoBackground: contentfulImage(contentful_id: { eq: "4BwBlnlreNXmJrwFXNTsbr" }) {
        ...WebsiteImage
      }
      reputationFaqs: contentfulAccordion(contentful_id: { eq: "HbVPtz3686fCuen8ZMnEp" }) {
        ...Accordion
      }
      emailFaqs: contentfulAccordion(contentful_id: { eq: "54JX5r7bUDGaqwVO91RdKs" }) {
        ...Accordion
      }
      directMailFaqs: contentfulAccordion(contentful_id: { eq: "6W9sPY6Y0euAWUptrCdBWR" }) {
        ...Accordion
      }
      listingScanSocialIcons: contentfulImage(contentful_id: { eq: "7GQJTczzKdmLJx8t8sGqQ2" }) {
        ...WebsiteImage
      }
      yextListingsScanForm: contentfulInlineMarketingForm(
        contentful_id: { eq: "2UEzBngoSQS0f8OkxC9SI1" }
      ) {
        ...InlineMarketingForm
      }
      campaignBuildingMp4: contentfulImage(contentful_id: { eq: "1A613euvxO1KoQ80jlgblL" }) {
        ...WebsiteImage
      }
      reviewSourcesMp4: contentfulImage(contentful_id: { eq: "4x8vrRkVIoiAgO7SmiA3Mz" }) {
        ...WebsiteImage
      }
      emailAutomationMp4: contentfulImage(contentful_id: { eq: "4YDqn1PGkqkOon34VgzeWu" }) {
        ...WebsiteImage
      }
      reputationManagementMp4: contentfulImage(contentful_id: { eq: "3IY9OUNdMYj7RFCiwQdap7" }) {
        ...WebsiteImage
      }
    }
  `);

  return {
    campaignBuildingMp4,
    customerEngagementImage,
    demoFormSection,
    directMailFaqs,
    driveRevenueImage,
    emailAutomationMp4,
    emailFaqs,
    emailPerformanceImage,
    emailSeo,
    heroInlineMarketingForm,
    heroVideoDirectMail,
    heroVideoEmail,
    heroVideoReputation,
    listingScanSocialIcons,
    mailSeo,
    marketingProVideo,
    measureRoiImage,
    reputationFaqs,
    reputationManagementMp4,
    reputationSeo,
    reviewSourcesMp4,
    videoBackground,
    yextListingsScanForm,
  };
};

export default useMarketingProDetailData;
